import { render } from "./AlphabetMenu.vue?vue&type=template&id=6a977e19&scoped=true&ts=true"
import script from "./AlphabetMenu.vue?vue&type=script&lang=ts"
export * from "./AlphabetMenu.vue?vue&type=script&lang=ts"

import "./AlphabetMenu.vue?vue&type=style&index=0&id=6a977e19&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a977e19"]])

export default __exports__